export default __webpack_public_path__ + "static/media/cartilla.11be99ed.mp4";